export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

// All routes share /api prefix
export const ROUTES = {
  HEALTH: '/api/health',
  CUSTOMERS: '/api/customers',
  PRODUCTS: '/api/products',
  SALES_ORDERS: '/api/sales-orders',
  VENDOR_POS: '/api/vendor-purchase-orders',
  GOODS_RECEIPTS: '/api/goods-receipts',
  AP_INVOICES: '/api/ap-invoices',
  DASHBOARD: '/api/dashboard',

  // Phase 4 routes (/api prefix)
  INVENTORY_LOTS: '/api/inventory-lots',
  RAW_MATERIALS: '/api/raw-materials',
  FINISHED_PRODUCTS: '/api/finished-products',
  BATCH_RECORDS: '/api/batch-records',
  VENDORS: '/api/vendors',
  COA_RECORDS: '/api/coa-records',
  NC_LOGS: '/api/nc-logs',
  QUARANTINE_RECORDS: '/api/quarantine-records',
  MOC_RECORDS: '/api/moc-records',
  SCAR_RECORDS: '/api/scar-records',
  TEMP_DEVIATIONS: '/api/temp-deviations',
  DOCUMENTS: '/api/documents',
  EQUIPMENT: '/api/equipment',
  TRAINING_RECORDS: '/api/training-records',

  // Phase C
  RECEIVING_PHOTOS: '/api/receiving-photos',
  SHIPMENT_PHOTOS:  '/api/shipment-photos',

  // Stage 2–4 (Migrations 015–022)
  ROOMS:                          '/api/rooms',
  MATERIAL_CONTROL_CARDS:         '/api/material-control-cards',
  RETURN_AUTHORIZATIONS:          '/api/return-authorizations',
  MANUFACTURING_RECORD_TEMPLATES: '/api/manufacturing-record-templates',

  CUSTOMER_APPROVED_PRODUCTS:     '/api/customer-approved-products',

  // Group 2 QMS entities
  MATERIAL_FAMILIES:              '/api/material-families',
  PACKAGING_COMPONENTS:           '/api/packaging-components',
  LOT_PALLETS:                    '/api/lot-pallets',
  RETAIN_SAMPLES:                 '/api/retain-samples',
  CARRIERS:                       '/api/carriers',
  FORM_1087:                      '/api/form-1087',
  SHIPMENTS:                      '/api/shipments',
  VAP_RECORDS:                    '/api/vap-records',

  // Directive G
  ROOM_LOGS:                      '/api/room-logs',

  // Batch Costing
  BATCH_COSTING:                  '/api/batch-costing',
  ADMIN_COST_POOL_PAYROLL:        '/api/admin/cost-pool/payroll',
  ADMIN_COST_POOL_ROOM_OVERHEAD:  '/api/admin/cost-pool/room-overhead',

  // Finance
  FINANCE_PL:                     '/api/finance/pl',
  FINANCE_MONTHS:                 '/api/finance/months',
  FINANCE_LIVE_ACTUALS:           '/api/finance/live-actuals',

  // CAPA Records (migration 046)
  CAPA_RECORDS:                   '/api/capa-records',

  // Maintenance Requests (migration 036)
  MAINTENANCE_REQUESTS:           '/api/maintenance-requests',

  // Expenses + GL Codes
  EXPENSES:                       '/api/expenses',
  GL_CODES:                       '/api/gl-codes',
  USERS:                          '/api/users',

  // Stage 6 Pass A — Shop Floor QMS
  TRAINING_PROGRAMS:              '/api/training-programs',
  TRAINING_EVENTS:                '/api/training-events',
  CALIBRATION_RECORDS:            '/api/calibration-records',
  CALIBRATION_SCHEDULE:           '/api/calibration-schedule',
  ENVIRONMENTAL_SAMPLES:          '/api/environmental-samples',
  ENVIRONMENTAL_MONITORING_ZONES: '/api/environmental-monitoring-zones',
  ATP_SWAB_LOGS:                  '/api/atp-swab-logs',

  // Stage 6 Pass B — Governance QMS
  INTERNAL_AUDIT_SCHEDULES:       '/api/internal-audit-schedules',
  INTERNAL_AUDITS:                '/api/internal-audits',
  ANNUAL_PRODUCT_REVIEWS:         '/api/annual-product-reviews',
  MANAGEMENT_REVIEWS:             '/api/management-reviews',
  CONTINUOUS_IMPROVEMENT:         '/api/continuous-improvement',
  EMERGENCY_DRILLS:               '/api/emergency-drills',
  PEST_CONTROL:                   '/api/pest-control',
  CHEMICAL_INVENTORY:             '/api/chemical-inventory',
  VISITOR_LOG:                    '/api/visitor-log',
  GLASS_BREAKAGE:                 '/api/glass-breakage',

  // Sprint 3 — CCP Logs + Customer Complaints (migration 062)
  CCP_LOGS:                       '/api/ccp-logs',
  CUSTOMER_COMPLAINTS:            '/api/customer-complaints',

  // VQP-13 — Food Safety Programs (migration 148)
  HACCP_PLANS:                    '/api/haccp-plans',
  FOOD_DEFENSE_ASSESSMENTS:       '/api/food-defense-assessments',
  FSMA_TRACEABILITY_LOGS:         '/api/fsma-traceability-logs',
  // FOOD-DEFENSE-1 (mig 417)
  FOOD_DEFENSE_VULNERABILITIES:   '/api/food-defense-vulnerabilities',
  FOOD_DEFENSE_MITIGATION:        '/api/food-defense-mitigation',
  FOOD_DEFENSE_MONITORING:        '/api/food-defense-monitoring',

  // Reports
  REPORTS_REVENUE:                '/api/reports/revenue-by-customer',
  REPORTS_BATCH:                  '/api/reports/batch-yield',
  REPORTS_NC:                     '/api/reports/nc-frequency',
  REPORTS_VENDOR:                 '/api/reports/vendor-on-time',
};
